export default function MenuItem({
  id = null,
  parent = null,
  type = null,
  target = null,
  url = null,
  title = null,
  endpoint = null
}) {
  this._id = id
  this._parent = parent
  this._type = type
  this._url = url
  this._title = title
  this._endpoint = endpoint
}

MenuItem.prototype.getId = function() {
  return this._id
}

MenuItem.prototype.setId = function(id) {
  this._id = id
}

MenuItem.prototype.getParent = function() {
  return this._parent
}

MenuItem.prototype.setParent = function(parent) {
  this._parent = parent
}

MenuItem.prototype.getType = function() {
  return this._type
}

MenuItem.prototype.setType = function(type) {
  this._type = type
}

MenuItem.prototype.getUrl = function() {
  return this._url
}

MenuItem.prototype.setUrl = function(url) {
  this._url = url
}

MenuItem.prototype.getTitle = function() {
  return this._title
}

MenuItem.prototype.setTitle = function(title) {
  this._title = title
}

MenuItem.prototype.getEndpoint = function() {
  return this._endpoint
}

MenuItem.prototype.setEndpoint = function(endpoint) {
  this._endpoint = endpoint
}



// WEBPACK FOOTER //
// ./src/entities/MenuItem.js